import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTenantFeatures } from "@/context/TenantFeaturesContext";

type PromptAdminRouteProps = {
  children: ReactNode;
};

/** Redirects home unless tenant allows prompt admin for this user (GET /tenant/features). */
export function PromptAdminRoute({ children }: PromptAdminRouteProps) {
  const { loading, showPromptAdmin } = useTenantFeatures();

  if (loading) {
    return null;
  }

  if (!showPromptAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
